// View-model adapters for the Workflow Creation Canvas.
//
// The vm is the canonical in-memory graph. React Flow nodes/edges are a
// PROJECTION of it, and the persisted shape is produced by the existing
// transformer (workflowTransformer.js) fed by `toRFArrays` — that math is
// unchanged, so saved bytes cannot drift.
//
// Nodes and edges are normalized (keyed by id + an order array) so mutations are
// per-id and projection is cheap. `activities` stays a plain array: it is a
// denormalized list always rebuilt in bulk from node forms today
// (rebuildActivitiesFromNodes), so keeping it as an array makes
// toRFArrays(normalize(x)) trivially identity-safe.
//
// The RENDER projection (vm -> RF arrays) is realized by the memoized
// `selectNodes`/`selectEdges` selectors plus the canvas's existing
// `edgesWithTheme` memo — no separate `project()` helper is needed.

export function normalize(nodes = [], edges = [], activities = []) {
  const nodesById = {};
  const nodeOrder = [];
  for (const n of nodes) {
    nodesById[n.id] = n;
    nodeOrder.push(n.id);
  }
  const edgesById = {};
  const edgeOrder = [];
  for (const e of edges) {
    edgesById[e.id] = e;
    edgeOrder.push(e.id);
  }
  return { nodesById, nodeOrder, edgesById, edgeOrder, activities: [...activities] };
}

export function toRFArrays(vm) {
  return {
    nodes: vm.nodeOrder.map((id) => vm.nodesById[id]),
    edges: vm.edgeOrder.map((id) => vm.edgesById[id]),
    activities: vm.activities,
  };
}

export function emptyVM() {
  return { nodesById: {}, nodeOrder: [], edgesById: {}, edgeOrder: [], activities: [] };
}
